<template>
    <div class="darkBG productBG" :style="{background:'url('+newsBg2+')'}" v-loading="loading">
        <div class="productPage contentBox mainContent">
            <div class="productPageTitle">
                <div
                :id="'type' + item.id"
                v-for="item in categoryList"
                :key="item.id"
                :class="['productPageTitleText', $route.query.category == item.id ? 'active' : '']"
                @click="getProductsData(item.id,0,1,false,true)"
                >
                {{item.title}}
              </div>
            </div>
            <div class="productPageBG">
                <div class="productType">
                  <div class="titleBox">
                    <div class="title">
                      品牌
                      <div class="filters">
                        <ul>
                          <li class="active" @click="fillterBrand='brand0'" :ref="'brand0'">不限</li>
                          <li v-for="item in brandList" :key="item.id" :ref="'brand'+item.id" @click="fillterBrand = 'brand'+item.id">{{ item.title }}</li>
                        </ul>
                      </div>
                    </div>
                    <div class="title">
                      分类
                      <div class="filters">
                        <ul>
                          <li @click="fillterType='cate0'" :ref="'cate0'" class="active">不限</li>
                          <li v-for="item in categoryList2" :key="item.id" :ref="'cate'+item.id" @click="fillterType = 'cate'+item.id">{{ item.title }}</li>
                        </ul>
                      </div>
                    </div>
                  </div>                  
                </div>
                <ProductList v-if="!isEmpty" :data="productDataList"/>
                <div v-if="isEmpty">
                  <el-empty description="没有商品"></el-empty>
                </div>
            </div>   
            <div class="pageButton">
              <el-pagination
                background
                layout="prev, pager, next"
                :current-page = "currentPage"
                :page-count="totalPage"
                @current-change="changePage"
                >
              </el-pagination>
            </div>       
        </div>

        <div class="mob">
          <div class="card">
            <div class="filter">
              <h3>实验设备</h3>
              <button @click="drawer=true">筛选</button>
            </div>
            <ProductList v-if="!isEmpty" :data="productDataList" :isMob="true"/>
            <div v-if="isEmpty">
              <el-empty description="没有商品"></el-empty>
            </div>
          </div>
          <div class="pageButton">
            <el-pagination
              background
              :small="true"
              layout="prev, pager, next"
              :current-page = "currentPage"
              :page-count="totalPage"
              @current-change="changePage"
              >
            </el-pagination>
          </div> 

          <el-drawer
            title="筛选"
            :visible.sync="drawer"
            size="50%"
            direction="btt">
            <div class="cate">
              <div class="productPageTitleText">
                用途
              </div>
              <div
                :id="'typeM' + item.id"
                v-for="item in categoryList"
                :key="item.id"
                :class="['productPageTitleText', $route.query.category == item.id ? 'active' : '']"
                @click="getProductsData(item.id,0,1,false,true)"
                >
                {{item.title}}
              </div>
            </div>   
            <div class="cate">
              <div class="productPageTitleText">
                品牌
              </div>
              <div class="productPageTitleText active" @click="fillterBrand='brand0'" :ref="'Mbrand0'">不限</div>
              <div
                v-for="item in brandList"
                :key="item.id"
                :ref="'Mbrand'+item.id"
                :class="['productPageTitleText', $route.query.category == item.id ? 'active' : '']"
                @click="fillterBrand = 'brand'+item.id"
                >
                {{item.title}}
              </div>
            </div>    
            <div class="cate">
              <div class="productPageTitleText">
                分类
              </div>
              <div @click="fillterType='cate0'" :ref="'Mcate0'" class="productPageTitleText active">不限</div>
              <div
                v-for="item in categoryList2"
                :key="item.id"
                :ref="'Mcate'+item.id"
                :class="['productPageTitleText', $route.query.category == item.id ? 'active' : '']"
                @click="fillterType = 'cate'+item.id"
                >
                {{item.title}}
              </div>
            </div>       
          </el-drawer>
        </div>
    </div>
</template>

<script>
import ProductList from '@/components/ProductList.vue';
//静态资源导入
import newsBg2 from '@/assets/img/newsBg2.jpg'

export default {
  name: 'productPage',
  components: {
    ProductList
  },
  watch:{    
    'type':function(){
      this.changePage(1,true);
    },
    'fillterBrand':function(){      
      let refName = this.fillterBrand.toString();

      //提取品牌ID 删除brand字符
      let branId = refName.replace('brand','');
      this.brand = branId;
      
      //查找所有brand开头的ref 并删除active
      let refList = Object.keys(this.$refs);

      for(let item of refList){
        if(item.startsWith('brand')||item.startsWith('Mbrand')){
          try{
            this.$refs[item].forEach(element => {
              element.classList.remove('active'); 
            });
          }
          catch{
            this.$refs[item].classList.remove('active');  
            console.log("warning: refList is not an object")
          }   
        }
      }
      //为激活的元素添加active
      if(this.$root.isMob){
        refName = 'M' + refName;
      }
      if(this.fillterBrand != "0"){
        if(Array.isArray(this.$refs[refName])){
          this.$refs[refName][0].classList.add('active');  
        }
        else{        
          this.$refs[refName].classList.add('active');  
        } 
      }      
      else{
        this.$refs['brand0'].classList.add('active');
      }
      this.changePage(1,true);  
    },
    'fillterType':function(){
      let refName = this.fillterType.toString();

      //提取分类ID 删除cate字符
      let cateId = refName.replace('cate','');
      this.type = cateId;

      //查找所有cate开头的ref 并删除active
      let refList = Object.keys(this.$refs);
      
      for(let item of refList){
        if(item.startsWith('cate')||item.startsWith('Mcate')){
          try{
            this.$refs[item].forEach(element => {
              element.classList.remove('active');  
            });
          }
          catch{
            this.$refs[item].classList.remove('active');  
            console.log("warning: refList is not an object")
          }                    
        }
      }           
      //为激活的元素添加active
      if(this.$root.isMob){
        refName = 'M' + refName;
      }
      if(this.fillterType != "0"){
        if(Array.isArray(this.$refs[refName])){
        this.$refs[refName][0].classList.add('active');  
        }
        else{        
          this.$refs[refName].classList.add('active');  
        }    
      } 
      else{
        this.$refs['cate0'].classList.add('active');
      }     
    },
  },
  data() {
    return {
      //静态资源导入S
      newsBg2:newsBg2,
      //静态资源导入E
      baseUrl:window.config.apiUrl,
      totalPage:1,
      currentPage:1,
      type:1,
      categoryList:[],
      categoryList2:[],
      productDataList:[],
      brandList:[],
      fillterBrand:'',
      fillterType:'',
      brand:0,
      isEmpty:false,
      drawer:false,
      loading:false,
    }
  },
  methods: {
    async getBaseData(type = 1,brand = 0,page = 1,onlyProducts = false) {
      this.loading = true;
      if(!onlyProducts){
        this.categoryList = await this.$root.getCategoryData();
        this.brandList = await this.$root.getBrandData(type);        
        this.categoryList2 = await this.$root.getCategoryData(type);
      }    
      let limit = 8;
      if(this.$root.isMob){
        limit = 4;
      }    
      let productInfo = await this.$root.getProductListData(type,brand,page,limit);        
      this.productDataList = productInfo[0];
      if(this.productDataList.length == 0){
        this.isEmpty = true;
      }
      else{
        this.isEmpty = false;
      }
      this.totalPage = productInfo[1].data.last_page;
      this.$root.loadingClose();
      this.loading = false;
    },
    async getProductsData(type = 1,brand=0,page = 1,onlyProducts=false,updateAll = false) {
      this.loading = true;
      if(updateAll){
        let allType = document.querySelectorAll('.productPageTitleText');
        allType.forEach(element => {
            element.classList.remove('active');
        });
        
        let target = document.getElementById('type'+type);
        let targetM = document.getElementById('typeM'+type);
        if(target){
            this.$nextTick(function(){
              target.classList.add('active');
            })
        }   
        if(targetM){
          this.$nextTick(function(){
            targetM.classList.add('active');
          })
        }
        //添加默认筛选激活
        this.fillterBrand = "0";
        this.fillterType = "0";
      }           
      
      this.type = type;
      await this.getBaseData(type,brand,page,onlyProducts);
      this.fixHeight();
      this.loading = false;
    },
    changePage(page,isChangeType = false){
      if(this.currentPage == 1 && isChangeType == false){
        //修复翻页
        let number = document.querySelectorAll('.number');
        number[0].classList.remove("active");
      }
      this.currentPage = page;
      this.getProductsData(this.type,this.brand,page,true);
    },
    fixHeight(){
        //修复背景高度
        let productPageBG = document.getElementsByClassName('productPageBG')[0];
        let productPage = document.getElementsByClassName('productPage')[0];        
        let productBG = document.getElementsByClassName('productBG')[0];
        let productList = document.getElementById('productList');
        if(productList && productPageBG && productPage){
          productPageBG.style.height = productList.offsetHeight + 400 + 'px';
          productPage.style.height = productList.offsetHeight + 400 + 'px';
          productBG.style.height = productList.offsetHeight + 600 + 'px';
        }

        if(this.$root.isMob){
          let num = this.productDataList.length;
          if(num == 0){
            num = 2;
          }
          productPageBG.style.height = (num*100) + 200 + 'px';
          productPage.style.height = (num*100) + 200 + 'px';
          productBG.style.height = (num*100) + 200 + 'px';
        }
    }
  },
  mounted() {    
    this.$nextTick(function () {
      //修复翻页
      let number = document.querySelectorAll('.number');
      number[0].classList.add("active");
      this.getProductsData();    
    });    
  }
}
</script>

<style lang="scss" src="@/assets/css/productListPage.scss" scoped></style>